"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.defaultState = void 0;

var _immutable = require("immutable");

var _auth = require("../actions/auth");

const defaultState = (0, _immutable.fromJS)({
  isFetching: false,
  user: undefined,
  error: undefined
});
exports.defaultState = defaultState;

const auth = (state = defaultState, action) => {
  switch (action.type) {
    case _auth.AUTH_REQUEST:
      return state.set('isFetching', true);

    case _auth.AUTH_SUCCESS:
      return state.set('user', (0, _immutable.fromJS)(action.payload));

    case _auth.AUTH_FAILURE:
      return state.set('error', action.payload && action.payload.toString());

    case _auth.AUTH_REQUEST_DONE:
      return state.set('isFetching', false);

    case _auth.LOGOUT:
      return state.set('user', undefined).set('isFetching', false);

    default:
      return state;
  }
};

var _default = auth;
exports.default = _default;